export enum ZoomCommand
{
    ZOOM_IN = '+',
    ZOOM_OUT = '-',
    ZOOM_RESET = '*',
    ZOOM_MIN = "/"
}
